module.exports = __webpack_public_path__ + "static/media/avatar_43.0e996054.svg";